/**
 * @method splitCamelCase
 * @description Splits a camel case string into separate words.
 * @param value - The camel case string to split.
 * @returns The string with spaces inserted between each word.
 */
export const splitCamelCase = (value: string) => value?.replace(/([a-z])([A-Z])/g, '$1 $2');

/**
 * @method capitalizeWords
 * @description Capitalizes the first letter of each word in a string.
 * @param value - The string to capitalize.
 * @returns The capitalized string.
 */
export const capitalizeWords = (value: string) => value?.split(' ')?.map((word: string) => word[0].toLocaleUpperCase() + word.slice(1))?.join(' ');
